// ABOUTME: The tenant's display label of the market concept in the current locale.
// ABOUTME: Every visible market string uses it; code identifiers stay `market`.

import { useAuth } from '@src/hooks';
import { useIntl } from 'react-intl';

import { resolveMarketLabel, toSentenceLabel } from '../utils/resolveMarketLabel';

/**
 * Returns the label (`Market`, or the tenant's `marketScoping.label` for the locale) and its
 * in-sentence form. `labelOverride` replaces the session label, for screens such as the system
 * settings that read the label from the settings themselves (the module may still be off).
 */
export function useMarketLabel(labelOverride?: Record<string, string> | null): {
    label: string;
    labelLower: string;
} {
    const intl = useIntl();
    const { sessionData } = useAuth();
    const fallback = intl.formatMessage({ id: 'market.label', defaultMessage: 'Market' });
    const label = resolveMarketLabel(
        labelOverride ?? sessionData?.marketContext?.label,
        intl.locale,
        fallback,
    );
    return { label, labelLower: toSentenceLabel(label, intl.locale) };
}

export default useMarketLabel;
